import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import api, { resolveImg } from "../lib/api";

export default function Welcome() {
  const { t, toggle, lang } = useLang();
  const { user, loading } = useAuth();
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setLogo(r.data.logo_url || null)).catch(() => {});
  }, []);

  if (!loading && user) return <Navigate to="/" replace />;

  return (
    <div dir={lang === "ar" ? "rtl" : "ltr"} className="noise min-h-screen bg-[#0B0A08] flex flex-col relative overflow-hidden">
      {/* ambient glow */}
      <div className="pointer-events-none absolute -top-40 start-1/2 -translate-x-1/2 w-[680px] h-[680px] rounded-full bg-[#C49A6C]/10 blur-[120px]" />

      {/* language toggle */}
      <div className="absolute top-6 end-6 z-10">
        <button
          onClick={toggle}
          data-testid="welcome-language-toggle"
          className="text-xs uppercase tracking-[0.2em] text-[#EAE3D8] hover:text-white transition-colors border border-[#4A4A46] px-3 py-1.5"
        >
          {lang === "en" ? "العربية" : "English"}
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 relative z-[2]">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="w-full max-w-lg text-center"
        >
          {logo ? (
            <img src={resolveImg(logo)} alt="OMR PERFUMER" className="h-16 md:h-20 w-auto object-contain mx-auto mb-8" />
          ) : (
            <div className="serif text-[#F2EBE1] text-3xl md:text-4xl tracking-[0.28em] mb-8">OMR PERFUMER</div>
          )}

          <p className="text-[11px] md:text-xs uppercase tracking-[0.34em] text-[#C49A6C] mb-6">
            {lang === "ar" ? "أبوظبي · الإمارات" : "Abu Dhabi · UAE"}
          </p>

          <h1 className="serif text-4xl md:text-5xl leading-[1.05] text-[#F2EBE1]">
            {t("welcome_title")}
          </h1>

          <p className="text-sm md:text-base text-[#8A857D] leading-relaxed mt-6 max-w-md mx-auto">
            {t("welcome_sub")}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mt-11 justify-center">
            <Link
              to="/login"
              data-testid="welcome-login-btn"
              className="flex-1 sm:flex-none sm:min-w-[190px] bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.25em] py-4 px-8 hover:bg-[#E7CBA9] transition-colors"
            >
              {t("login")}
            </Link>
            <Link
              to="/register"
              data-testid="welcome-register-btn"
              className="flex-1 sm:flex-none sm:min-w-[190px] border border-[#C49A6C] text-[#C49A6C] text-xs uppercase tracking-[0.25em] py-4 px-8 hover:bg-[#C49A6C] hover:text-[#0B0A08] transition-colors"
            >
              {t("register")}
            </Link>
          </div>


          <p className="text-[11px] text-[#6E685F] mt-10 leading-relaxed">
            {t("welcome_note")}
          </p>
          <Link to="/experiments" data-testid="welcome-lab-link" className="inline-block mt-8 text-[11px] uppercase tracking-[0.3em] text-[#C49A6C] hover:text-[#E7CBA9] transition-colors">
            OMR — Artisanal Experimental Lab →
          </Link>
        </motion.div>
      </div>

      <footer className="relative z-[2] text-center pb-8 text-[10px] uppercase tracking-[0.3em] text-[#4A463F]">
        © {new Date().getFullYear()} OMR PERFUMER
      </footer>
    </div>
  );
}
